import NoData from "../NoData";
import { useMatchInfo } from "./MatchInfoContext";

export default function LiveTab() {
  const {  heatMapLinkLive } = useMatchInfo();
  
  return (
    <div className="min-h-[12rem] rounded-lg bg-[var(--theme-bg)] text-[var(--theme-text)] border border-[var(--theme-border)]">
      {heatMapLinkLive ? (
        <iframe src={heatMapLinkLive} allowFullScreen className="w-full h-[320px] md:h-[800px]" />
      ) : (
        <NoData />
      )}
    </div>
  );
}
